import { createTheme } from 'styled-components';
import { borderRadius } from './borderRadius';
import { semantic, swatches } from './colors';
import { motion } from './motion';
import { dropShadow } from './shadows';
import { spacing } from './spacing';
import { fontSize, fontStyle, fontWeight, lineHeight, fontFamily, fontRole } from './typography';
import { zIndex } from './zIndex';
export const rawTheme = {
    fontSize,
    fontStyle,
    fontWeight,
    lineHeight,
    fontFamily,
    fontRole,
    borderRadius,
    spacing,
    motion,
    zIndex,
    dropShadow,
    swatches,
    semantic,
};
/**
 * The Tetris theme contract, built with styled-components' native `createTheme`.
 *
 * Every leaf is a typed `var(--t-*, fallback)` reference — use it directly in styles:
 * ```
 * color: ${theme.semantic.foreground.primary};
 * padding: ${theme.spacing['2xl']};
 * background: color-mix(in srgb, ${theme.swatches.gray[900]}, transparent 50%);
 * ```
 *
 * - `theme.GlobalStyle` emits every token as a `--t-*` CSS custom property on `:root`,
 *   from whichever theme the surrounding `ThemeProvider` holds.
 * - `theme.vars` mirrors the theme shape with the bare property names (`--t-swatches-blue-500`),
 *   for writing overrides without hand-typing variable names.
 *
 * The `t` prefix is load-bearing: plain CSS files (e.g. the pleditor stylesheets) reference
 * `--t-*` variables directly.
 */
export const theme = createTheme(rawTheme, { prefix: 't' });
